import {Injectable} from '@angular/core';
import {BasicArea} from '../../../resources/basic-area/basic-area.interface';
import {Building} from '../../../resources/building/building.interface';
import {Area} from '../../../resources/area/area.interface';
import {Project} from '../../../resources/project/project.interface';
import {BasicAreaStore} from '../basicarea/basicarea-store';
import {BuildingStore} from '../building/building-store';
import {AreaStore} from '../area/area-store';
import {ProjectStore} from './project-store';
import {ConstantsService} from '../../../services/constants.service';

@Injectable({
  providedIn: 'root'
})
export class ProjectStoreService {

  constructor(private projectStore: ProjectStore,
              private basicAreaStore: BasicAreaStore,
              private buildingStore: BuildingStore,
              private areaStore: AreaStore,
              private constantsService: ConstantsService) {
  }

  /**
   * Refactor from project.business.service
   */
  getConstructions() {

    let constructions: any[] = [];
    const project = this.projectStore.get();
    const basicAreas: BasicArea[] = this.basicAreaStore.getAll();
    const buildings: Building[] = this.buildingStore.getAll();
    const areas: Area[] = this.areaStore.getAll(); // do we really need to add this to the construction method?

    constructions.push({
      _id: project._id,
      name: project.name,
      projectLevel: 1,
      qualityLevel: project.qualityLevel,
      active: true
    });

    constructions = [...constructions, ...basicAreas, ...buildings, ...areas];
    const projectLevels = this.constantsService.getList('PROJECT_LEVELS');
    return constructions.map((constr) => {
      const pl = projectLevels.find((projLevel) => projLevel._id === constr.projectLevel);
      constr.displayName = `${pl.displayName}: ${constr.name}`;
      return constr;
    });
  }

  /**
   * Get project id.
   *
   * @returns Project id.
   */
  public getId(): Project['_id'] {
    return this.projectStore.get()._id;
  }

  /**
   * Get project language.
   *
   * @returns Project language.
   */
  public getLanguage(): Project['language'] {
    return this.projectStore.get().language;
  }

}
